module.exports = __webpack_public_path__ + "static/plesiosaurus-d1c27b69f42de122ee4d8b4075489591.jpeg";